<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">
            <v-row>
                <v-col>
                    <v-card :loading="loading">
                        <v-card-text>
                            <v-tabs v-model="tab">                    
                                <v-tab>
                                    <v-badge dot v-if="!valid7" color="red">Documenti</v-badge><span v-else>Documenti</span>
                                </v-tab>
                                <v-spacer></v-spacer>                    
                                <v-btn class="mt-2 mr-2"
                                    color="blue darken-2" dark
                                    @click.stop="chiudi">
                                    Esci
                                </v-btn>
                            </v-tabs>

                            <v-tabs-items v-model="tab">                    
                                <v-form ref="form7"
                                        v-model="valid7"
                                        lazy-validation>
                                    <v-tab-item>
                                        <br />
                                        <v-row>
                                            <v-col cols="8">
                                                <v-data-table class="elevation-1 ma-2"
                                                            v-model="selectedItem"
                                                            single-select
                                                            item-key="id"
                                                            :loading="loadingDoc"
                                                            :headers="headersAllegati"
                                                            :items="allegatiCliente"
                                                            :footer-props="{
                                                                    'items-per-page-text':'Pagina da',
                                                                    'items-per-page-all-text': '',
                                                                    'items-per-page-options':[8]
                                                                }"
                                                            @click:row="selezionaRiga"
                                                            loading-text="Caricamento dati..."
                                                            no-data-text="Nessun allegato presente">
                                                    <template slot="body.append">
                                                        <tr>
                                                            <th class="title"></th>
                                                            <th class="title"></th>
                                                            <th class="title"></th>
                                                            <th class="title"></th>
                                                            <th class="title">
                                                                <v-icon class="mr-2"
                                                                        @click="newAllegato"
                                                                        color="success darken-2">
                                                                    mdi-file-document-plus-outline
                                                                </v-icon>
                                                            </th>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:item.dataIns="{ item }">
                                                        <span v-text="localData(item.dataIns)" />
                                                    </template>
                                                    <template v-slot:item.note="{ item }">
                                                        <v-tooltip slot="append" bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field v-on="on" v-model="item.note"
                                                                            class="mb-n6"
                                                                            outlined
                                                                            dense />
                                                            </template>
                                                            <span>{{item.allegatoName}}</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-slot:item.apri="{ item }">
                                                        <v-icon @click="viewAllegato(item)" color="info darken-2">mdi-magnify</v-icon>
                                                    </template>
                                                    <template v-slot:item.scarica="{ item }">
                                                        <v-icon @click="downloadAllegato(item)" color="info darken-2">mdi-download</v-icon>
                                                    </template>
                                                    <template v-slot:item.invia="{ item }">
                                                        <v-icon @click="inviaMail(item)" color="success">mdi-email-fast-outline</v-icon>
                                                    </template>
                                                    <template v-slot:item.azioni="{ item }">
                                                        <v-icon @click="eliminaAllegato(item)" color="error darken-2">mdi-trash-can-outline</v-icon>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                            <v-col cols="3">

                                                <v-card v-if="allegatiOpen" :loading="loadingPdf">
                                                    <v-carousel v-model="carouselId"
                                                                show-arrows
                                                                @change="changeCarusel">
                                                        <v-carousel-item v-for="(item) in allegatiCliente"
                                                                        :key="item.id"
                                                                        target="_blank"
                                                                        :href="item.allegatoPath ? item.allegatoPath : 'pdf/blank.pdf'">
                                                            <pdf @progress="progress" v-if="item.isPdf" :src="item.allegatoPath"></pdf>
                                                            <pdf @progress="progress" v-if="item.isBlank" :src="'pdf/blank.pdf'"></pdf>
                                                            <pdf @progress="progress" v-if="item.isNotPreview" :src="'pdf/notpreview.pdf'"></pdf>
                                                            <v-img v-if="item.isImage" :src="item.allegatoPath" contain max-height="300"></v-img>
                                                        </v-carousel-item>
                                                    </v-carousel>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <br />
                                    </v-tab-item>
                                </v-form>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-slide-y-transition>
        <v-file-input v-model="fileDocumento"
                      prepend-icon=""
                      id="idFileDocumentoCliente"
                      label="File Documento"
                      outlined
                      hide-input
                      type="file"
                      @change="uploadCliente"
                      multiple
                      dense>
        </v-file-input>

        <v-snackbar v-model="snackSuccess" centered
                    timeout="2000"
                    color="success">
            <v-icon dark>
                mdi-checkbox-marked-circle
            </v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackError" centered
                    timeout="2000"
                    color="error">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
        <v-snackbar v-model="snackCancel" centered
                    timeout="2000"
                    color="warning">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Modifiche annullate.
        </v-snackbar>
        <v-snackbar v-model="snackRemote" centered
                    timeout="2000"
                    color="info">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Aggiornamento remoto.
        </v-snackbar>
    </v-container>        
</template>

<script>

    import { callService, callPost, callPostMultipart, euro, gLocalData, gCheckData, gServerData, gDataCalendar,Snack, gControllData } from '@/modules/utilities.js'
    import pdf from 'vue-pdf'
    import { bus } from '@/main.js'

    export default {
        components: {
            pdf
        },
        data: () => ({            
            valid7: true,
            viewTab: true,
            expanded: [],
            carouselId: null,
            fileDocumento: null,
            documentoInviato: null,
            allegatiOpen: false,
            selectedItem: [],
            tab: 0,
            tabPrec:0,
            loadingSalva: false,
            loadingAnnulla: false,
            loading: false,
            loadingDoc: false,
            loadingPdf: false,
            snackSuccess: false,
            snackError: false,
            snackCancel: false,
            snackRemote: false,
            theme:'',
            allegatiCliente: [],
            headersAllegati: [
                { text: '', value: 'apri', sortable: false },
                { text: '', value: 'scarica', sortable: false },
                { text: '', value: 'invia', sortable: false },
                { text: 'Data Aggiornamento', value: 'dataIns' },
                { text: 'Note', value: 'note', width: '50%' },
                { text: '', value: 'azioni', sortable: false }
            ],
        }),
        mounted() {
            if (!this.$store.state.logged) {
                this.$router.replace({ name: "login" }).catch(() => { });
            }            
        },
        methods: {
            progress(val) {
                this.loadingPdf = (val < 1)
            },
            newAllegato(item) {
                let fileDocumento = document.getElementById('idFileDocumentoCliente')
                fileDocumento.click();
            },
            controllData(v) {
                return gControllData(v);
            },
            async uploadCliente() {
                this.loadingDoc=true;
                const formData = new FormData();
                formData.append('partition', this.$store.state.partition);
                formData.append('username', this.$store.state.utente.username);
                formData.append('token', this.$store.state.utente.token);
                formData.append('idCliente', this.cliente.id);
                for(let i=0;i<this.fileDocumento.length;i++) {
                    formData.append('fileDocumenti', this.fileDocumento[i]);
                }              
                let checkSave = this.checkSave;
                const esito = await callPostMultipart('api/allegatoCliente/upload', formData);
                this.loadingDoc=false;

                if (esito) this.snackSuccess = true;
                else this.snackError = true;

                if (esito) {
                    let param=[this.cliente.id]
                    this.allegatiCliente = await callService("api/allegatocliente", param);
                    this.allegatiOpen = this.allegatiCliente.length>0;
                }
                this.fileDocumento = null;

                this.$nextTick(() => {
                    this.checkSave=checkSave; //ripristino il valore precedente
                });            
            },
            viewAllegato(item) {
                window.open(item.allegatoPath);
            },
            downloadAllegato(item) {
                var link = document.createElement('a');
                link.href = item.allegatoPath;
                link.download = item.allegato;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            async eliminaAllegato(item) {
                bus.$emit('msg-open', { message: "Eliminare l'allegato?", item });
                bus.$on('msg-cancel', this.eliminaAllegatoCancel);
                bus.$on('msg-ok', this.eliminaAllegatoOk);
            },
            async eliminaAllegatoCancel(item) {
                bus.$off('msg-cancel', this.eliminaAllegatoCancel);
                bus.$off('msg-ok', this.eliminaAllegatoOk);
            },
            async eliminaAllegatoOk(item) {
                bus.$off('msg-cancel', this.eliminaAllegatoCancel);
                bus.$off('msg-ok', this.eliminaAllegatoOk);
                
                let indexAllegato = this.allegatiCliente.indexOf(item);

                let param = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.utente.username,
                    token: this.$store.state.utente.token,
                    idAllegatoCliente: item.id
                };

                this.loadingDoc = true;
                let checkSave = this.checkSave;
                const esito = await callPost('api/allegatoCliente/elimina', param);
                this.loadingDoc = false;

                if (esito) {
                    this.allegatiCliente.splice(indexAllegato, 1);
                    this.snackSuccess = true;
                }
                else this.snackError = true;

                this.$nextTick(() => {
                    this.checkSave=checkSave; //ripristino il valore precedente
                });

            },   
            selezionaRiga(item) {
                this.selectedItem = [item];
                this.carouselId = this.allegatiCliente.indexOf(item);
            },
            changeCarusel(i) {
                this.selectedItem = [this.allegatiCliente[i]];
            },
            inviaMail(item) {
                //let idx = this.listaTask.findIndex(t => t.operatore.id && t.operatore.id != '0' && t.dataEsecuzione == null);
                var filtro = this.$store.state.contattiEstesi.find(ce => ce.cliente.id === this.cliente.id);
                var indirizzo = '';
                if (filtro) {
                    indirizzo = filtro.mailList[0];
                    //alert(indirizzo);
                }

                this.documentoInviato = item;
                //alert(this.documentoInviato.allegatoPath);

                //console.log(JSON.stringify(filtro.ListaRecapitiMail));
                bus.$emit('msg-mail-open',
                    {
                        message: "In allegato il documento richiesto",
                        label: "Invio documento", value: this.cliente.denominazioneNormalizzata,
                        item: this.cliente, title: ": documento del cliente " + this.cliente.denominazioneNormalizzata,
                        mail: indirizzo
                    });
                bus.$on('msg-mail-cancel', this.inviaMailCancel);
                bus.$on('msg-mail-ok', this.inviaMailOk);
            },
            inviaMailCancel(cliente) {
                bus.$off('msg-mail-cancel', this.inviaMailCancel);
                bus.$off('msg-mail-ok', this.inviaMailOk);
            },
            async inviaMailOk(cliente, descrizione, mail, message) {
                //alert(mail);
                //alert(message);
                bus.$off('msg-mail-cancel', this.inviaMailCancel);
                bus.$off('msg-mail-ok', this.inviaMailOk);
                //await this.save(false, false, false, descrizione);
                await this.inviaDocumento(message, mail);
            },

            async inviaDocumento(message, mail) {
                this.loadingPdf = true;
                //invia la mail al cliente corrente
                let param = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.utente.username,
                    token: this.$store.state.utente.token,
                    sessionID: this.$store.state.sessionID,
                    cliente: this.cliente.id,
                    file: this.documentoInviato.allegatoPath,
                    studio: this.$store.state.studioName,
                    messaggio: message,
                    mail: mail
                };

                //alert(JSON.stringify(param));

                const result = await callPost('api/broadcast/inviaDocumentoCliente', param);
                this.loadingPdf = false;

                if (!result) {
                    await this.internalCreated(Snack.error);
                }
                if (result.spedita) await this.internalCreated(Snack.success);
                else {
                    bus.$emit('msg-simple-open', { title: "Mail non iviata", message: "Non sono disponibili indirizzi mail per questo cliente" });
                }
            },            
            importoEuro(v) {
                return euro(v);
            },
            checkData(d) {
                return gCheckData(d);
            },
            localData(v) {
                return gLocalData(v);
            },
            serverData(stringDate) {                             
                return gServerData(stringDate);                
            },
            dataCalendar(stringDate) {                             
                return gDataCalendar(stringDate);                
            }, 
            chiudi() {
                this.dialog=false;    
            },            
        },
        computed: {
            admin(){
                return this.$store.state.admin;
            },
            isLavoro() {
                return this.$store.state.lplApp && this.$store.state.lplApp.isLavoro;
            },
            isContabilita(){
                return this.$store.state.lplApp && this.$store.state.lplApp.isContabilita;
            },
            isPulizia() {
                return this.$store.state.lplApp && this.$store.state.lplApp.isPulizia;
            },
            isManutenzione() {
                return this.$store.state.lplApp && this.$store.state.lplApp.isManutenzione;
            },
            isChiamata() {
                return this.$store.state.lplApp && this.$store.state.lplApp.isChiamata;
            },
            isServicePro() {
                return this.$store.state.lplApp && (this.$store.state.lplApp.isPulizia || this.$store.state.lplApp.isChiamata || this.$store.state.lplApp.isManutenzione);
            },
            isStudioPro() {
                return this.$store.state.lplApp && (this.$store.state.lplApp.isLavoro || this.$store.state.lplApp.isContabilita);
            },
            isStudioProLight() {
                return this.$store.state.parametri && this.$store.state.parametri.isStudioProLight;
            },
            
        },
        watch:{
            allegatiCliente: {
                handler() {
                    this.checkSave = true;
                },
                deep: true,
            }
        },
        async created() {
            let theme = this.$cookie.get('theme') == "true"; //trasformo da string a bool
            this.theme = theme;
            this.tab = 0;            
            let param = ["11e94c08-5066-47af-81ee-8c36cd7c0781"];
            this.allegatiCliente = await callService("api/allegatocliente", param);
            this.allegatiOpen = this.allegatiCliente.length > 0;
        }
    }

</script>

<style>
    .style-lock {
        color: grey
    }
</style>
